import { Box, CircularProgress, Typography } from '@mui/material';
import React, { FC } from 'react';
import styled from 'styled-components';

export const LoadMoreFeedLoader: FC = () => (
  <Container>
    <CircularProgress size={32} />
  </Container>
);

const FeedLoader: FC = () => (
  <Container>
    <CircularProgress size={20} />
    <Typography variant="caption">Feed is loading...</Typography>
  </Container>
);

export default FeedLoader;

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 240px;
`;
